import React, {createRef, useState, useContext} from 'react';
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import __ from "lodash";
import moment from "moment/moment";
import MaterialTable from "@material-table/core";
import { defaultComponents, MaterialTableBody, MaterialTableBodyRow } from '../../../controls/Material-Table-Components';
import { v4 as uuidv4 } from 'uuid';

import SystemContext from "../../../SystemContext";

import {ColumnWidth, ValidatorColumn} from "../../../blocks/ColumnHelper";
import {useFlightManifestContentAwbs} from "../../../services/flightManifests";
import {MaskedNumber, AwbNumber} from "../../../controls";
import { useTheme } from '@material-ui/core';


const dateFormat = "DD/MM/YYYY HH:mm";

const FlightManifestAwbs = (_props) => {
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const tableRef = createRef({state: {lastEditingRow: false}});
  const {isAuthenticated} = useAuth0();
  const eventBus = SystemData.eventBus;

  const props = {
    ..._props
  }
  const {classes, extraKeys} = props;

  const [state] = useState({
    canEdit: props.canEdit,
    activeRow: null
  });

  const queryClient = useQueryClient();
  const ulds = useFlightManifestContentAwbs({queryClient, extraKeys});

  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      editable: state.canEdit?"always":"never",
      emptyValue: "",
      initialEditValue: "",
      sorting: false
    };
    const defaultEditProps = {
      style:{fontSize: "0.875rem"}
    };

    //const validatorColumn = ValidatorColumn(DeadloadEditorValidator, false);

    return [
      //{...validatorColumn},
      {
        ...baseColumn,
        ...ColumnWidth(100,[5,2],undefined,undefined,undefined,undefined,false),
        title: "AWB",
        field: "awbPrefix",
        render: (props) => (
          <span>{`${String(props.awbPrefix).padStart(3, '0')}-${String(props.awbSerial).padStart(8,'0')}`}</span>
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(50,[5,2],undefined,undefined,undefined,undefined,false),
        title: "Pieces",
        field: "pieces",
        type: "numeric"
      },
      {
        ...baseColumn,
        ...ColumnWidth(80,5,2,{width: 80, paddingLeft: 5, maxWidth: 80},undefined,undefined,undefined,false),
        title: "Weight",
        field: "weight",
        type: "numeric",
        render: (props) => (
          <MaskedNumber
            displayType="text"
            value={props.weight}
            decimalScale={1}
            fixedDecimalScale={true}
            fullWidth
            suffix={props.weightUom}
            style={{ fontSize: "0.875rem", textAlign: "right" }}
          />
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(80,5,2,{width: 80, paddingLeft: 5, maxWidth: 80},undefined,undefined,undefined,false),
        title: "Volume",
        field: "volume",
        type: "numeric",
        render: (props) => (
          <MaskedNumber
            displayType="text"
            value={props.volume}
            decimalScale={2}
            fixedDecimalScale={true}
            fullWidth
            suffix={props.volumeUom}
            style={{ fontSize: "0.875rem", textAlign: "right" }}
          />
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(345,5,2,{width: 345, paddingLeft: 5, maxWidth: 345},undefined,undefined,undefined,false),
        title: "Commodity",
        field: "commodity",
      },
      {
        ...baseColumn,
        ...ColumnWidth(180,5,2,{width: 180, paddingLeft: 5, maxWidth: 180},undefined,undefined,undefined,false),
        title: "SHC",
        field: "awbShcs",
        render: (rowData) => rowData.awbShcs && Array.isArray(rowData.awbShcs) ? rowData.awbShcs.join(", ") : ""
      },
    ];
  };


  const bodyRef = createRef();

  return (isAuthenticated &&
        <div className={classes.TripLegEditor} style={{overflow: "scroll", marginLeft: 20}}>
          <MaterialTable
            tableRef={tableRef}
            data={ulds.data}
            style={{
              backgroundColor: "#fdfdfd",
              boxShadow: "none",
              border: "1px solid #aaaaaa",
              borderRadius: 0,
            }}
            options={{
              actionsColumnIndex: -1,
              search: false,
              cellStyle: {
                padding: "8px 2px",
              },
              headerStyle: {
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                color: theme.palette.childTableHeader.textColor,
                padding: "2px",
              },
              toolbarButtonAlignment: "right",
              detailPanelType: "single",
              showTitle: false,
              toolbar: false,
              padding: 'dense',
              paging: false,
              filtering: false,
              draggable: false,
              grouping: false
            }}
            components={{
              ...defaultComponents,
              Body: (props) => (
                <MaterialTableBody
                  {...props}
                  ref={bodyRef}
                  rowHeight={46}
                  overscanRowCount={10}
                  addVirtualScrolling={true}
                  bodyHeight={200}
                  headerHeight={46}
                />
              ),
              Row: (props) => (
                <MaterialTableBodyRow
                  {...props}
                />
              ),
            }}
            title="Flight Manifest"
            columns={getColumns({...props, canEdit: state.canEdit})}
            editable={{
              isEditable: () => {
                return state.canEdit;
              },
              isDeletable: () => {
                return state.canEdit;
              },
              onRowAdd: undefined,
              onRowUpdate:  undefined,
              onRowDelete: undefined,
            }}
        />
      </div>
  );
}

export default FlightManifestAwbs;
